import React from "react";
import styled from "styled-components";
import { IconSvg } from "monica-alexandria";
import { read_timeline_iso_date } from "../../../utils/timeline/timeline_normalization";
import {
    legacyActivityDateOptions,
    legacyActivityTimeOptions,
    read_legacy_activity_date
} from "./legacy_activity_formatting";

const TimelineLegacySchedule = styled.p`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem 0.5rem;
    margin: 0;
    color: ${p => p.theme.color};

    span,
    time {
        color: inherit;
        overflow-wrap: anywhere;
    }
`;

const TimelineLegacyScheduleLabel = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;

    svg {
        width: 1.4rem;
        height: 1.4rem;
        fill: currentColor;
    }
`;

// Displays the appointment date separately from the historical action's own time.
export const Timeline_Legacy_Activity_Schedule = (props) => {
    const schedule = read_timeline_iso_date(props.event?.detail?.schedule);
    const label = props.event?.type === "MEETING" ? "Meeting" : "Callback";

    return (
        <TimelineLegacySchedule>
            <TimelineLegacyScheduleLabel>
                <IconSvg Icon="Calendar" />
                <span>{props.t(label)}</span>
            </TimelineLegacyScheduleLabel>
            <time dateTime={schedule || undefined}>
                {read_legacy_activity_date(schedule, { ...legacyActivityDateOptions, ...legacyActivityTimeOptions }) || props.t("Date unavailable")}
            </time>
        </TimelineLegacySchedule>
    );
};
